import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Buttons from "../../components/Button/Button";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CustomerDashboard from "../../components/CustomerDashboard/CustomerDashboard";
import "./Dashboard.scss";
import OrderRow from "../../components/Orderrow/Orderrow";
import arr from "../../assets/arrow.png";
import { campaignData } from "../../store/action";
import Button from "../../components/Button/Button";

const Samples = () => {
	const { t } = useTranslation();
	const history = useHistory();
	const campaign = useSelector((state) => state.campaign.campaign);
	const [campBool, setCampBool] = useState(false);
	const [total, setTotal] = useState(0);
	let tempCampaign = [...campaign];
	const dispatch = useDispatch();

	useEffect(() => {
		totCal();
	}, [campaign]);

	const totCal = () => {
		var sum = [];
		campaign.map((data) => {
			data.colors &&
				data.size &&
				sum.push(Number(data.quantity) * Number(data.realprice));
			data?.variation?.length > 0 &&
				data.variation.map((variant) => {
					variant.colors &&
						variant.size &&
						sum.push(Number(variant.quantity) * Number(variant.realprice));
				});
		});
		if (sum.length) {
			setTotal(sum?.reduce((x, y) => x + y));
		} else {
			setTotal(0);
		}
	};

	const setBool = () => {
		const index = campaign.filter((element) => element.quantity > 0);
		if (index.length > 0) {
			setCampBool(true);
		} else {
			setCampBool(false);
		}
	};

	const remove = (data, index) => {
		if (
			tempCampaign[index]?.variation ||
			tempCampaign[index]?.variation?.length
		) {
			tempCampaign[index].variation = [];
		}
		tempCampaign[index].variation = [];
		tempCampaign[index].quantity = 0;
		tempCampaign[index].size = "";
		tempCampaign[index].colors = "";
		setredux();
		totCal();
		setBool();
	};

	const removeVar = (index, ind) => {
		tempCampaign[index].variation[ind].quantity = 0;
		tempCampaign[index].variation[ind].size = "";
		tempCampaign[index].variation[ind].colors = "";
		setredux();
		totCal();
	};

	const setredux = () => {
		dispatch(
			campaignData({
				campaign: tempCampaign,
			}),
		);
	};

	const AddtoCart = (data) => {
		const exist = campaign?.find((item) => item.id === data?.id);
		if (exist) {
			setCampBool(true);
			dispatch(
				campaignData({
					campaign: campaign.map((x) =>
						x.id === data?.id ? { ...exist, quantity: exist.quantity + 1 } : x,
					),
				}),
			);
		} else {
			setCampBool(true);
			dispatch(
				campaignData({
					campaign: [...campaign, { ...data, quantity: 1 }],
				}),
			);
		}
	};

	useEffect(() => {
		setBool();
	}, []);

	return (
		<div className="home">
			<div className="left">
				<CustomerDashboard />
			</div>
			<div className="right">
				<div className="order">
					<div className="order-left">
						<div className="head">
							<div>
								<h2>{campBool ? t("add-product") : t("select-prod")}</h2>
							</div>
							{campBool && (
								<div>
									<Buttons
										text={t("add-another")}
										style={{ width: "135px", fontSize: "11px", height: "35px" }}
										onClick={() => setCampBool((prev) => !prev)}
									/>
								</div>
							)}
						</div>
						<div className="tail">
							<div>
								<div>
									{campBool ? (
										<table
											style={{ width: "100%", textAlign: "left" }}
											CELLSPACING="0"
											CELLPADDING="0"
										>
											<thead>
												<tr>
													<th style={{ paddingLeft: "10px" }}>
														{t("product")}
													</th>
													<th>{t("color")}</th>
													<th style={{ textAlign: "center" }}>
														<div style={{ marginLeft: "-140px" }}>
															{t("size")}
														</div>
													</th>
													<th>{t("quantity")}</th>
													<th>{t("price")}</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>
														<hr />
													</td>
													<td>
														<hr />
													</td>
													<td>
														<hr />
													</td>
													<td>
														<hr />
													</td>
													<td>
														<hr />
													</td>
													<td>
														<hr />
													</td>
												</tr>
												{campaign.map((data, ind) => {
													return (
														data.quantity !== 0 && (
															<>
																<OrderRow
																	data={data}
																	index={ind}
																	remove={remove}
																	removeVar={removeVar}
																	setBool={setBool}
																	Sample
																/>
															</>
														)
													);
												})}
											</tbody>
										</table>
									) : (
										campaign.map((data, ind) => {
											return (data.isDone && !data.isStop) ||
												(!data.isDone && !data.isStop) ? (
												<div className="sample-bottom">
													<div style={{ display: "flex" }}>
														<div>
															<img
																src={data.designShirt}
																width={80}
																height={100}
															/>
														</div>
														<div
															style={{ marginLeft: "10px", marginTop: "25px" }}
														>
															<p style={{ fontWeight: "bold" }}>
																{data.shirtName}
															</p>
														</div>
													</div>
													<div>
														<Button
															text={t("select")}
															pic={arr}
															style={{
																background: "#fff",
																color: "#000",
																width: "135px",
															}}
															onClick={() => AddtoCart(data)}
														/>
													</div>
												</div>
											) : null;
										})
									)}
								</div>
							</div>
						</div>
					</div>
					<div className="order-right">
						<h3>{t("ord-sum")}</h3>
						{campaign.map((data, index) => {
							return data.quantity > 0 && data.colors && data.size ? (
								<div className="order-bottom">
									<div className="gutter-bottom">
										<div style={{ display: "flex", alignItems: "center" }}>
											<div>
												<img src={data.designShirt} width={80} height={100} />
											</div>
											<div>
												<p style={{ marginLeft: "10px" }}>
													<b>{data.shirtName}</b>
												</p>
												<small>
													<span
														style={{
															background: data.colors,
															color: data.colors,
														}}
														className="col-box"
													></span>
													<span>{data.size}</span>
													<span>Qty:{data.quantity}</span>
												</small>
											</div>
										</div>
										<div style={{ textAlign: "right", marginTop: "25px" }}>
											<DeleteOutlineOutlinedIcon
												onClick={() => remove(data, index)}
												className="cp"
											/>
											<p>
												<small>
													<span>
														Prix:
														{Number(data.quantity) * Number(data.realprice)}€
													</span>
												</small>
											</p>
										</div>
									</div>
									{data?.variation?.length > 0 &&
										data.variation.map((variant, ind) => {
											return variant.quantity > 0 &&
												variant.colors &&
												variant.size ? (
												<div className="gutter-bottom">
													<div
														style={{ display: "flex", alignItems: "center" }}
													>
														<div>
															<img
																src={variant.designShirt}
																width={80}
																height={100}
															/>
														</div>
														<div>
															<p style={{ marginLeft: "10px" }}>
																<b>{variant.shirtName}</b>
															</p>
															<small>
																<span
																	style={{
																		background: variant.colors,
																		color: variant.colors,
																	}}
																	className="col-box"
																></span>
																<span>{variant.size}</span>
																<span>Qty:{variant.quantity}</span>
															</small>
														</div>
													</div>
													<div
														style={{ textAlign: "right", marginTop: "25px" }}
													>
														<DeleteOutlineOutlinedIcon
															onClick={() => removeVar(index, ind)}
															className="cp"
														/>
														<p>
															<small>
																<span>
																	Prix:
																	{Number(variant.quantity) *
																		Number(variant.realprice)}
																	€
																</span>
															</small>
														</p>
													</div>
												</div>
											) : null;
										})}
								</div>
							) : null;
						})}
						{total > 0 && (
							<>
								<div className="checkout">
									<p>
										<b>Le Total:</b> {total}€
									</p>
								</div>
								<div className="checkout-btn ">
									<Buttons
										text={t("checkout")}
										onClick={() =>
											history.push({
												pathname: "/pay",
												state: total,
											})
										}
										style={{ width: "180px" }}
									/>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
export default Samples;
